module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_3.c9d983fe.png";